import shouldForwardProp from '@styled-system/should-forward-prop';
import styled, { css, keyframes } from 'styled-components';

type SharedProps = Readonly<{
  display?: 'inline-flex';
}>;

const spinKeyframes = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

type StaticRotationProps = Readonly<{
  isRotated?: boolean;
  degrees: number;
}> & SharedProps;

type SpinProps = Readonly<{
  spin: boolean;
}> & SharedProps;

type Props = SpinProps | StaticRotationProps;

const spin = (props: Props) => {
  if ('spin' in props && props.spin) {
    return css`
      animation: ${spinKeyframes} ${({ theme }) => theme.scTheme.animations.durations.slow} infinite;
    `;
  }

  return null;
};

const rotation = (props: Props) => {
  if ('degrees' in props) {
    const { isRotated = false, degrees } = props;
    if (isRotated) {
      return css`
        transform: rotate(${degrees}deg);
      `;
    }

    return css`
      transform: rotate(0deg);
    `;
  }

  return null;
};

const Rotate = styled.div.withConfig({
  shouldForwardProp: (prop) => shouldForwardProp(prop),
})<Props>`
  display: ${({ display }) => display};
  ${rotation}
  ${spin}
  transition: transform ${({ theme }) => theme.scTheme.animations.durations.fast};
  transition-timing-function: ${({ theme }) => theme.scTheme.animations.timingFunctions.fast};
`;

export default Rotate;
